document.addEventListener("DOMContentLoaded", () => {
  const boxes = document.querySelectorAll(".trackview");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        // If you only want it once:
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 }); // 0.2 = 20% of element visible

  boxes.forEach(box => observer.observe(box));



// function Marquee(selector, speed) {
//   const parentSelector = document.querySelector(selector);
//   const clone = parentSelector.innerHTML;
//   const firstElement = parentSelector.children[0];
//   let i = 0;
//   console.log(firstElement);
//   parentSelector.insertAdjacentHTML('beforeend', clone);
//   parentSelector.insertAdjacentHTML('beforeend', clone);

//   setInterval(function () {
//     firstElement.style.marginLeft = `-${i}px`;
//     if (i > firstElement.clientWidth) {
//       i = 0;
//     }
//     i = i + speed;
//   }, 0);
// }
// window.addEventListener('load', Marquee('.marquee', 0.2))



});




document.addEventListener("DOMContentLoaded", function () {
  function wrapRegisteredSymbols(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.includes("®")) {
        // Replace raw ® with sup-wrapped version
        const replaced = node.textContent.replace(/®/g, "<sup>®</sup>");
        if (replaced !== node.textContent) {
          const span = document.createElement("span");
          span.innerHTML = replaced;
          node.replaceWith(span);
        }
      }
    } else {
      // Skip if we're already inside a <sup>
      if (node.nodeName !== "SUP") {
        node.childNodes.forEach(wrapRegisteredSymbols);
      }
    }
  }

  wrapRegisteredSymbols(document.body);
});




document.addEventListener("DOMContentLoaded", function () {
  const bars = document.querySelectorAll(".stats .bar");

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const bar = entry.target;
        const width = bar.getAttribute("data-width");
        bar.style.width = width + "%"; // triggers your CSS animation
        obs.unobserve(bar); // stop observing once animated
      }
    });
  }, {
    threshold: 0.3 // trigger when at least 30% of the bar is visible
  });

  bars.forEach(bar => observer.observe(bar));
});